import { Column } from '@/components/SettingsLayout';
import { Button } from '@/ui';
import styles from '../styles.module.css';
import ImageWithFallback from '@/ui/ImageWithFallBack/ImageWithFallBack';

type Props = {
  showButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  imageSrc?: string;
};

export const EmptyResiduals = ({
  showButton = false,
  buttonText,
  onButtonClick,
  imageSrc = '/empty_state.svg',
}: Props) => {
  return (
    <Column gapSize='16' align='center' justify='justify-center'>
      <div className={styles.emptyImage}>
        <ImageWithFallback src={imageSrc} alt='residuals empty state' width={320} height={213} />
      </div>
      {showButton && buttonText && onButtonClick && (
        <Button variant='primary' onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </Column>
  );
};
